// extracted by mini-css-extract-plugin
export default {"home":"home_lspsY","card":"card_oofj3","cover":"cover_onixU","skeleton":"skeleton_pwHN9"};